import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { ItemCardSource, useTrackItemCardClicked } from '@/utils/amplitude/analytics';

export const LARGE_IMAGE_SIZE = 280;
export const THUMB_IMAGE_SIZE = 128;

type Props = {
    alt: string;
    catalogId: number;
    href: string;
    imageSize: number;
    itemId: number;
    promoted: boolean;
    src: string;
    srcSet?: string;
    trackItemCardClicked: ReturnType<typeof useTrackItemCardClicked>;
};

export const CoverLotImage = ({
    alt,
    catalogId,
    href,
    imageSize,
    itemId,
    promoted,
    src,
    srcSet,
    trackItemCardClicked,
}: Props) => (
    <RouteLink
        className="flex h-full w-full items-center justify-center"
        onClick={() => {
            trackItemCardClicked({
                catalogId,
                itemId,
                promoted,
                source: ItemCardSource.CoverLots,
            });
        }}
        to={href}
    >
        <img
            alt={alt}
            className="max-h-full max-w-full object-contain"
            height={imageSize}
            src={src}
            srcSet={srcSet}
            width={imageSize}
        />
    </RouteLink>
);
